import { StudioContext } from '@home/pages/studio/context';
import { getReportInfo } from '@op/components/LeftMenu/getRoprtInfo';
import { getWebEnv } from '@op/hooks/useGetPageSourceRule';
import { getCompetitorTableHeader, listMenu } from '@op/services';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';

type CompetitorGame = {
  edition_unified_id: string;
  entity_type: string;
  id_type: string;
  release_time: string;
};

export default function OpinionsCommonData(props: any) {
  const { filter, children, tabs, ...restProps } = props;
  // 竞品游戏接口数据
  const [competitorGames, setCompetitorGames] = useState<CompetitorGame[]>([]);
  const [competitorLoading, setCompetitorLoading] = useState(false);
  const [competitorError, setCompetitorError] = useState(false);
  const [reportUrl, setReportUrl] = useState('');

  const { currentGame } = useContext(StudioContext);
  const { unified_edition_id: gameid, game_type: gameType } = currentGame || {};
  // 获取竞品游戏数据
  const getCompetitorGames = async () => {
    setCompetitorLoading(true);
    try {
      const result: any = await getCompetitorTableHeader({
        edition_unified_id: filter?.edition_unified_id,
        entity_type: filter?.entity_type,
        exclude_stats_data: true,
        id_type: filter?.id_type,
      });
      setCompetitorGames(result);
    } catch (error) {
      setCompetitorError(true);
      setCompetitorGames([]);
    } finally {
      setCompetitorLoading(false);
    }
  };

  // 获取游戏对应舆情的菜单列表
  const getOpinionsMenuList = () => {
    listMenu({
      web_env: getWebEnv(),
      edition_unified_id: gameid,
      id_type: 'unified_id',
      entity_type: gameType,
    }).then((data: any) => {
      const report = data?.find((item: any) => item.name_en === 'Report') || {};
      // 如果报告菜单下面挂有报告，则展示报告按钮
      if (report?.opinion_list?.length > 0) {
        const firstReport = report?.opinion_list?.[0] || {};
        const firstReportInfo = getReportInfo(
          firstReport,
          firstReport?.name_en,
        );
        let url = firstReportInfo.actualPath;
        if (url.includes('?')) {
          url = `${url}&gameid=${gameid}`;
        } else {
          url = `${url}?gameid=${gameid}`;
        }
        setReportUrl(url);
      }
    });
  };

  useEffect(() => {
    getOpinionsMenuList();
  }, [gameid, gameType]);

  useEffect(() => {
    getCompetitorGames();
  }, []);

  const competitorGamesData = useMemo(
    () => ({
      data: competitorGames,
      loading: competitorLoading,
      error: competitorError,
    }),
    [competitorGames, competitorLoading, competitorError],
  );

  const numCards = tabs?.length || 0;
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const refArray = Array.from({ length: numCards }, () => useRef(null));

  return React.Children.map(children, (child: any) =>
    React.cloneElement(child, {
      competitorGamesData,
      filter,
      refArray,
      tabs,
      reportUrl,
      ...restProps,
    }),
  );
}
